import angular from 'angular';
import addressModal from './addressModal';
import './style.scss';

export default angular
  .module('components.addressModal', [])
  .component('addressModal', addressModal).name;
